// extracted by mini-css-extract-plugin
export default {"cls1":"Neoaq1WIeory1qpaJ1mH","cls2":"QVffOBcpu3Axkp40QTtC Neoaq1WIeory1qpaJ1mH"};